import { Input, FormGroup, Label, Row, Col, Table } from "reactstrap";
import { useContext } from "react";
import DataTableNested from "../../../components/DataTableNested";
import { QuoteDataContext } from "../contexts/quoteDataContext";
import Collapsable from "../../../components/Collapsable";

const QuoteReviewWarningsTable = ({
    warnings,
    header,
    onAcknowledgedWarningChange,
    onApprovedWarningChange
}) => {
    const quoteDataContext = useContext(QuoteDataContext);

    const columns = [
        {
            /* THIS IS THE FIELD USED FOR COLLAPSABLE SECTIONS IN TABLE */
            key: "warning",   
            label: "Warning",
            style: { width: "350px" },
            render: (value, row, isExpanded, hasChildren) => {
                if (!hasChildren) return null;

                return (
                    <div style={{display: "block"}}>
                        <Row className="align-items-center">
                            <Col xs="auto">
                                <i className="bi bi-exclamation-triangle text-warning"></i> 
                            </Col>
                            <Col className="p-0">
                                <strong>{value || ""}</strong><br></br>   
                                <span className="text-muted">&nbsp;{`(${row.items.length} items)`}</span>
                            </Col>
                        </Row>
                    </div>
                );
            }
        },
        {
            key: "detail",
            label: "Detail",
            style: { width: "350px" },
            render: (value, row, isExpanded, hasChildren) => {
                return (
                    value
                )
            }
        },
        {
            key: "acknowledged",
            label: "Acknowledged?",
            style: { width: "130px" },
            render: (value, row, isExpanded, hasChildren) => {
                if (hasChildren) {
                    return (
                        <FormGroup switch>
                            <Input
                                type="switch"
                                checked={row.items.filter(x => x.acknowledged).length === row.items.length}
                                disabled={!isExpanded}
                                onChange={(e) => {
                                    for (const item of row.items) {
                                        onAcknowledgedWarningChange(item.id, e.target.checked);
                                    }
                                }}
                            /> ({row.items.filter(x => x.acknowledged).length}/{row.items.length})
                        </FormGroup>
                    )
                } else if (!hasChildren) {
                    return (
                        <FormGroup switch>
                            <Input
                            type="switch"
                            checked={value}
                            onChange={(e) => onAcknowledgedWarningChange(row.id, e.target.checked)}
                            />
                        </FormGroup>
                    )
                }

            }
        },
        {
            key: "acknowledgedBy",
            label: "Acknowledged By",
            style: { width: "170px" },
            render: (value, row, isExpanded, hasChildren) => {
                if (hasChildren) {
                    return (
                        [...new Set(
                            row.items.filter(x => x.acknowledged).map(item =>
                                quoteDataContext.users.find(user => user.userGuid === item.acknowledgedBy)?.fullName ?? "unknown"
                            )
                        )].join(", ")
                    )
                } else {
                    return (
                        row.acknowledged 
                            ? quoteDataContext.users.find(user => user.userGuid === value)?.fullName ?? "unknown"
                            : ""
                    )
                }
            }
        },
        /*
        {
            key: "approved",
            label: "Approved?",
            style: { width: "130px" },
            render: (value, row, isExpanded, hasChildren) => {
                if (hasChildren) {
                    return (
                        <FormGroup switch>
                            <Input
                            type="switch"
                            checked={row.items.filter(x => x.approved).length === row.items.length}
                            disabled={!isExpanded}
                        onChange={(e) => {
                            for (const item of row.items) {
                                onApprovedWarningChange(item.id, e.target.checked);
                            }
                        }} /> ({row.items.filter(x => x.approved).length}/{row.items.length})
                    </FormGroup>
                    )
                } else if (!hasChildren) {
                    return (
                        <FormGroup switch>
                            <Input
                            type="switch"
                            checked={value}
                            onChange={(e) => onApprovedWarningChange(row.id, e.target.checked)}
                            />
                        </FormGroup>
                    )
                }
            }
        },
        {
            key: "approvedBy",
            label: "Approved By",
            style: { width: "170px" },
            render: (value, row, isExpanded, hasChildren) => {
                if (hasChildren) {
                    return (
                        [...new Set(
                            row.items.filter(x => x.approved).map(item =>
                                quoteDataContext.users.find(user => user.userGuid === item.approvedBy)?.fullName ?? "unknown"
                            )
                        )].join(", ")

                    )
                } else {
                    return (
                        row.approved
                            ? quoteDataContext.users.find(user => user.userGuid === value)?.fullName ?? "unknown"
                            : ""
                    )
                }
            }
        }
        */
    ].map(col => ({
        // Add default styles for all columns here
        ...col,
        align: "left"
    })) 

    const stats = {
        totalWarnings: warnings.flatMap(w => w.items).length,
        totalAcknowledged: warnings.flatMap(w => w.items).filter(i => i.acknowledged).length,
        totalApproved: warnings.flatMap(w => w.items).filter(i => i.approved).length
    };

    const sectionHeaderWithStats = `${(header ?? "Warnings")} (Acknowledged: ${stats.totalAcknowledged}/${stats.totalWarnings})`;
    //const sectionHeaderWithStats = `${(header ?? "Warnings")} (Acknowledged: ${stats.totalAcknowledged}/${stats.totalWarnings}, Approved: ${stats.totalApproved}/${stats.totalWarnings})`;

    return (
        <Collapsable header={warnings.length > 0 ? sectionHeaderWithStats : header + " (None)"} open={stats.totalWarnings > stats.totalAcknowledged} fluid>
            <>
                {warnings.length === 0 &&
                    <div>No warnings</div>
                }
                {(warnings.length > 0) && (
                    <DataTableNested
                        id="quote-review-warnings-table"
                        columns={columns}
                        data={warnings}
                        width="100%"
                    />            
                )}
            </>
        </Collapsable>
    );
}
export default QuoteReviewWarningsTable;